module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/metal-detector/metalDetector.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/metal-detector/metalDetector.png
// module id = 591
// module chunks = 0